import fetch from "isomorphic-fetch";
import {
	API2_URL,
	AMOUNTS_AGENCIES_REQUEST,
	AMOUNTS_AGENCIES_SHOW,
	AMOUNTS_AGENCIES_EDIT,
	AMOUNTS_AGENCIES_COMPLETE,
	AMOUNTS_AGENCIES_FAIL
} from "../store/config";
import {sessionService} from "redux-react-session";
import {newNotification} from "./notifications";
import _ from 'lodash';
import {versionsList} from "./versions";
import {modalitiesList} from "./modalities";
import {entitiesList} from "./entities";
import {history} from "../store/store";

export const amountsAgenciesShow = (page = 1,filters={}) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(amountsAgenciesRequest());
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			let params = '';
			_.mapKeys(filters, (value, key) => {
				if(value){
					params = `${params}&${key}=${value}`;
				}
			});

			return fetch(`${API2_URL}/version-modality-agenciable?page=${page}${params}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(amountsAgenciesData(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(amountsAgenciesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

export const amountsAgenciesEdit = (id = undefined) => (dispatch) => {
	dispatch(amountsAgenciesRequest());
	dispatch(entitiesList());

	return dispatch(versionsList())
		.then((versions) => {
			if(!_.isEmpty(versions.payload)){
				return dispatch(modalitiesList())
					.then((modalities) => {
						if(!_.isEmpty(modalities.payload)){
							if(id){
								return dispatch(fetchAmountsAgenciesEdit(id))
							} else {
								dispatch(amountsAgenciesComplete())
							}
						}else {
							return dispatch(amountsAgenciesFailed('Carga de monto instancia incompleta'));
						}
					})
			}else {
				return dispatch(amountsAgenciesFailed('Carga de monto instancia incompleta'));
			}
		})
}

const fetchAmountsAgenciesEdit = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/version-modality-agenciable/${id}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(agenciesAmountsEditData(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(amountsAgenciesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

export const amountsAgenciesEditSave = (values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(amountsAgenciesRequest());
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(values)
			};

			return fetch(`${API2_URL}/version-modality-agenciable${values.id ? `/${values.id}?_method=PUT`:''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message: "El monto se ha guardado correctamente", type: "success"}));
						if(_.isEmpty(values.id)){
							history.push(`/instancias/montos/editar/${json.data.id}`);
						}
						return dispatch(agenciesAmountsEditData(json))
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(amountsAgenciesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

export const amountAgencyDelete = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(amountsAgenciesRequest());
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'delete'
			};

			return fetch(`${API2_URL}/version-modality-agenciable/${id}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message: "El monto se ha eliminado correctamente", type: "success"}));
						dispatch(amountsAgenciesShow());
						return dispatch(amountsAgenciesComplete())
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(amountsAgenciesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

const amountsAgenciesData = (json) => {
	return {
		type: AMOUNTS_AGENCIES_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const agenciesAmountsEditData = (json) => {
	return {
		type: AMOUNTS_AGENCIES_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const amountsAgenciesRequest = () => {
	return {
		type: AMOUNTS_AGENCIES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const amountsAgenciesComplete = () => {
	return {
		type: AMOUNTS_AGENCIES_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

const amountsAgenciesFailed = (error) => {
	return {
		type: AMOUNTS_AGENCIES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/amounts_agencies.js